// Shared constants for beneficiary types and services
export const CLIENT_TYPES = [
  { value: 'diocese', label: 'Diocèse' },
  { value: 'paroisse', label: 'Paroisse' },
  { value: 'eglise', label: 'Église (mouvements, associations)' },
  { value: 'association_ig', label: "Association d'intérêt général" },
  { value: 'entreprise', label: 'Entreprise / Fédération Pro / Asso +50 sal.' },
];

export const CLIENT_TYPE_CONFIG = {
  diocese: { label: 'Diocèse', color: 'bg-indigo-100 text-indigo-800', pricingColor: 'bg-indigo-50' },
  paroisse: { label: 'Paroisse', color: 'bg-blue-100 text-blue-800', pricingColor: 'bg-blue-50' },
  eglise: { label: 'Église', color: 'bg-emerald-100 text-emerald-800', pricingColor: 'bg-emerald-50' },
  association_ig: { label: 'Asso. intérêt général', color: 'bg-amber-100 text-amber-800', pricingColor: 'bg-amber-50' },
  entreprise: { label: 'Entreprise / Fédé. Pro', color: 'bg-orange-100 text-orange-800', pricingColor: 'bg-orange-50' },
};

export const AVAILABLE_SERVICES = [
  { id: 'bouilloire', label: 'Bouilloire' },
  { id: 'machine_cafe', label: 'Machine à café' },
  { id: 'video_projection', label: 'Vidéo-projection' },
  { id: 'visio_conference', label: 'Visio-conférence' },
  { id: 'parking', label: 'Parking' },
  { id: 'menage', label: 'Ménage' },
];
